import * as React from "react";

const AvatarPlaceholderIcon: React.FC<{ size?: number }> = ({ size = 56 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="56" height="56" rx="28" fill="#E0DFE0" />
            <path d="M28 28C31.9354 28 35.125 24.8099 35.125 20.875C35.125 16.9401 31.9354 13.75 28 13.75C24.0646 13.75 20.875 16.9401 20.875 20.875C20.875 24.8099 24.0646 28 28 28ZM30.8222 30.6719H25.1778C19.8513 30.6719 15.5312 34.9914 15.5312 40.3185C15.5312 41.3839 16.3952 42.2483 17.4606 42.2483H38.5405C39.606 42.25 40.4688 41.3872 40.4688 40.3185C40.4688 34.9914 36.1492 30.6719 30.8222 30.6719Z" fill="#9E9D9E" />
        </svg>
    );
};

export default React.memo(AvatarPlaceholderIcon);
